import { render, staticRenderFns } from "./process-config.vue?vue&type=template&id=52c36057&scoped=true"
import script from "./process-config.vue?vue&type=script&lang=ts"
export * from "./process-config.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c36057",
  null
  
)

export default component.exports